import React from 'react';
import './MiniShimmerCard.css';

export interface MiniShimmerCardProps {
  /** Optional CSS class name */
  className?: string;
}

export const MiniShimmerCard: React.FC<MiniShimmerCardProps> = ({
  className = '',
}) => {
  const cardClasses = [
    'mini-shimmer-card',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses}>
      <div className="mini-shimmer-card__image mini-shimmer-card__shimmer"></div>
      <div className="mini-shimmer-card__content">
        <div className="mini-shimmer-card__title mini-shimmer-card__shimmer"></div>
        <div className="mini-shimmer-card__description mini-shimmer-card__shimmer"></div>
        <div className="mini-shimmer-card__description-line mini-shimmer-card__shimmer"></div>
        <div className="mini-shimmer-card__match mini-shimmer-card__shimmer"></div>
        <div className="mini-shimmer-card__actions">
          <div className="mini-shimmer-card__button mini-shimmer-card__shimmer"></div>
        </div>
      </div>
    </div>
  );
};
